import { useEffect, useRef, useState } from 'react';
import styled from 'styled-components';

const InfiniteSlider = ({ children, threshold = 0.5 }) => {
  const [isVisible, setIsVisible] = useState(false);
  const sliderRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
        }
      },
      { threshold },
    );

    if (sliderRef.current) {
      observer.observe(sliderRef.current);
    }

    return () => observer.disconnect();
  }, []);

  return (
    <SliderContainer ref={sliderRef}>
      {typeof children === 'function' ? children(isVisible) : children}
    </SliderContainer>
  );
};

const SliderContainer = styled.div`
  width: 100%;
  overflow: hidden;
`;

export default InfiniteSlider;
